import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Dashboard from "./Dashboard";
import Sell from "../Sell";
import Customers from "../Customers";
import Products from "../Products";
import Inventory from "../Inventory";
import SalesLedger from "./SalesLedger";
import Setup from "../Setup";
import Reporting from "../Reporting";
import BillingPlans from "./BillingPlans";

const DashboardParent = ({ match }) => (
  <Switch>
    <Redirect exact from={`${match.url}/`} to={`${match.url}/main`} />
    <Route
      path={`${match.url}/main`}
      render={(props) => <Dashboard {...props} />}
    />
    <Route path={`${match.url}/sell`} render={(props) => <Sell {...props} />} />
    <Route
      path={`${match.url}/salesLedger`}
      render={(props) => <SalesLedger {...props} />}
    />
    <Route
      path={`${match.url}/reporting`}
      render={(props) => <Reporting {...props} />}
    />
    <Route
      path={`${match.url}/Products`}
      render={(props) => <Products {...props} />}
    />
    <Route
      path={`${match.url}/Customers`}
      render={(props) => <Customers {...props} />}
    />
    <Route
      path={`${match.url}/Setup`}
      render={(props) => <Setup {...props} />}
    />
    <Route
      path={`${match.url}/BillingPlans`}
      render={(props) => <BillingPlans {...props} />}
    />
    <Route
      path={`${match.url}/Inventory`}
      render={(props) => <Inventory {...props} />}
    />
  </Switch>
);

export default DashboardParent;
